module.exports = __webpack_public_path__ + "img/image-1.66d7a176.png";